import type { LangLocaleDefinition } from "@/locales/langLocales";
import { computed } from "vue";
import {
  parseLangLocaleOrFallback,
  supportedLangLocales,
} from "@/locales/langLocales";
import userStore from "@/store/modules/userStore";
import { hasFeatureUsingUserStore } from "@/app/featureFlags";

export const useLocaleSelection = () => {
  const localeToFlagCss = (
    langLocaleDefinition: LangLocaleDefinition
  ): string => {
    return "custom-icon flag-icon-" + langLocaleDefinition.countryFlag;
  };

  const currentLanguageLocale = computed(() => {
    return parseLangLocaleOrFallback(userStore.state.userLanguageLocale);
  });

  const availableLanguageLocales = computed(() => {
    return supportedLangLocales.filter(
      (x) => !x.featureFlag || hasFeatureUsingUserStore(x.featureFlag)
    );
  });

  const setLanguage = async (languageLocale: string) => {
    await userStore.setLanguageLocale(languageLocale);
  };

  return {
    localeToFlagCss,
    currentLanguageLocale,
    availableLanguageLocales,
    setLanguage,
  };
};
